import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PageSizing } from '__components/Layout/PageContentWidth';
import { PrimaryObjectUploadContext } from '../../context';
import {
  StyledCard,
  StyledLoader,
  StyledStepHeader,
} from '__pages/SmartConnectors/SmartConnector/SmartConnectorWizard/steps/styles';
import { Settings } from './Settings';
import { PRIMARY_OBJECT_UPLOAD_STEPS } from '__pages/SmartConnectors/constants';
import { StyledCardHeaderWrapper } from '../../styles';
import { TextEllipsisWithTooltip } from '__components/Kizen/Table';

export const PreviewStep = () => {
  const { t } = useTranslation();
  const { setIsValid, loading, scope } = useContext(PrimaryObjectUploadContext);

  const isStepValid = true;

  useEffect(() => {
    setIsValid(isStepValid);
  }, [setIsValid, isStepValid]);

  return (
    <PageSizing>
      <StyledCard data-qa={`${PRIMARY_OBJECT_UPLOAD_STEPS.preview}-step`}>
        <StyledCardHeaderWrapper>
          <StyledStepHeader type="subheader">
            {t('Finalize Settings & Preview')}
          </StyledStepHeader>
          <TextEllipsisWithTooltip>{`${t('Scope')}: ${scope}`}</TextEllipsisWithTooltip>
        </StyledCardHeaderWrapper>
        <StyledLoader loading={loading}>
          <Settings />
        </StyledLoader>
      </StyledCard>
    </PageSizing>
  );
};
